var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHnscc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88 20.832V18.372C9.79 17.602 9.49999 17.002 8.79999 16.932L6.76001 16.732C6.17001 16.672 5.70002 16.152 5.65002 15.502L5.52997 12.832L4 12.242L5.42999 8.63197L5.38 8.53197C5.42 5.50197 7.65997 3.06197 10.41 3.05197C10.41 3.05197 12.3 2.87197 14.2 3.18197C16.3 3.53197 18.26 5.52197 18.48 7.79197C18.61 9.13197 18.24 10.602 17.87 11.682L16.41 14.792C16.4 14.862 16.38 14.932 16.37 15.022C16.24 15.992 16.37 16.992 16.67 17.912L17.63 20.742L9.87 20.852L9.88 20.832Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2905 9.18152C14.152 9.18152 14.8505 8.48309 14.8505 7.62152C14.8505 6.75996 14.152 6.06152 13.2905 6.06152C12.4289 6.06152 11.7305 6.75996 11.7305 7.62152C11.7305 8.48309 12.4289 9.18152 13.2905 9.18152Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5391 17.8223C13.6771 17.8223 13.7891 17.7103 13.7891 17.5723C13.7891 17.4342 13.6771 17.3223 13.5391 17.3223C13.401 17.3223 13.2891 17.4342 13.2891 17.5723C13.2891 17.7103 13.401 17.8223 13.5391 17.8223Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnscc);
export default __webpack_public_path__ + "static/media/HNSCC.fe77bf5346b393259bb9d969982db6ba.svg";
export { ForwardRef as ReactComponent };